const defaultState = null;

export default function groupEditorReducer(state, action) {
  let nextState = state.groupEditor;
  if (nextState === undefined) nextState = defaultState;
  switch (action.type) {
    case 'OPEN_GROUP_EDITOR':
      return {
        ...state,
        groupEditor: {
          open: true,
          group: action.group,
          isNew: action.isNew,
        },
      };
    case 'CLOSE_GROUP_EDITOR':
      return {
        ...state,
        groupEditor: {
          open: false,
          group: undefined,
          isNew: undefined,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/groupEditor.js